(() => {
  if (window.bwGiftBundleInitialized) return;
  window.bwGiftBundleInitialized = true;
  let busy = false;
  let retainedMessage = '';
  let retainedKey = '';
  const restoreMessage = () => {
    if (!retainedMessage) return;
    document.querySelectorAll('[data-bw-gift-bundle-add]').forEach(button => {
      if (button.dataset.bwGiftBundleAdd !== retainedKey) return;
      const status = button.closest('[data-bw-gift-offer]')?.querySelector('[data-bw-gift-bundle-status]');
      if (status && status.textContent !== retainedMessage) status.textContent = retainedMessage;
    });
  };
  if (document.body) new MutationObserver(restoreMessage).observe(document.body, { childList: true, subtree: true });
  const quantityFor = (cart, id) => cart.items.filter(item => String(item.variant_id) === String(id)).reduce((sum, item) => sum + item.quantity, 0);
  const request = async (path, body) => {
    const response = await fetch((window.Shopify?.routes?.root || '/') + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message);
    return data;
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-bw-gift-bundle-add]');
    if (!button || button.disabled || busy) return;
    event.preventDefault();
    const host = button.closest('[data-bw-gift-offer]');
    const status = host.querySelector('[data-bw-gift-bundle-status]');
    const label = button.textContent;
    retainedMessage = ''; retainedKey = button.dataset.bwGiftBundleAdd;
    busy = true; button.disabled = true; button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.loading; status.textContent = '';
    let submitted = false;
    try {
      const pack = JSON.parse(host.querySelector('[data-bw-gift-bundle-config]').textContent);
      if (!Array.isArray(pack) || pack.length < 2) throw new Error(button.dataset.unavailable);
      const cart = await request('cart.js');
      const sawQuantity = quantityFor(cart, pack[0].id);
      if (button.dataset.context === 'cart' && !sawQuantity) throw new Error(button.dataset.missingSaw);
      const quantityInput = host.closest('[data-bw-editorial]')?.querySelector('form[action*="/cart/add"] [name="quantity"]');
      const requested = button.dataset.context === 'cart' ? sawQuantity : Number(quantityInput?.value || 1);
      if (!Number.isSafeInteger(requested) || requested < 1) throw new Error(button.dataset.unavailable);
      const target = Math.max(requested, sawQuantity);
      const requiredFor = part => part.sharedSawIds ? part.sharedSawIds.reduce((sum, id) => sum + (String(id) === String(pack[0].id) ? target : quantityFor(cart, id)), 0) : target;
      const additions = pack.map(part => ({ id: part.id, quantity: Math.max(0, requiredFor(part) - quantityFor(cart, part.id)), handle: part.handle, sku: part.sku })).filter(part => part.quantity > 0);
      for (const part of additions) {
        const product = await request('products/' + encodeURIComponent(part.handle) + '.js');
        const variant = product.variants.find(item => String(item.id) === String(part.id) && item.sku === part.sku);
        if (!variant?.available) throw new Error(button.dataset.unavailable);
        const rule = variant.quantity_rule || {};
        if (part.quantity < (rule.min || 1) || (rule.max && part.quantity > rule.max) || part.quantity % (rule.increment || 1)) throw new Error(button.dataset.unavailable);
      }
      if (additions.length) {
        submitted = true;
        await request('cart/add.js', { items: additions.map(({ id, quantity }) => ({ id, quantity })) });
      }
      const verified = await request('cart.js');
      if (pack.some(part => quantityFor(verified, part.id) < requiredFor(part))) throw new Error(button.dataset.review);
      status.textContent = button.dataset.added;
      document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: additions.reduce((sum, item) => sum + item.quantity, 0), productAdded: true } }));
    } catch (error) {
      retainedMessage = submitted ? button.dataset.review : error.message || button.dataset.error;
      status.textContent = retainedMessage;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
    } finally {
      busy = false; button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = label;
    }
  });
})();
